import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux';
import BriefDefect from './BriefDefect';
import BriefElevation from './BriefElevation';
import { firebaseConnect } from 'react-redux-firebase';
import EmptyUserDefault from '../../../../assets/mics/emptyUser.png';
import * as MDICONS from '@material-ui/icons';
import moment from 'moment'
import ReactModal from 'react-modal';
import { addAComment, deleteAComment, openDeleteCommentModal } from '../../../../store/actions/sketchActions';
import Loader from 'react-loader-spinner';
import EditMarkerWrapper from '../editMarker/EditMarkerWrapper';
import DeleteCommentModal from './relatedModals/DeleteCommentModal';
import { get } from 'lodash'

class BriefMarkerWrapper extends Component {
    constructor(props) {
        super(props)

        this.state = {
            // MODAL
            showEditMarkerModal: false,
            showCommentImageModal: false,
            showCommentDeleteModal: false,

            // MAP
            commentMap: undefined,
            toBeDeletedCommentMap: undefined,

            // DETAILS
            commentText: "",
            commentImageFiles: [],
        }
    }

    /// README: HANDLING PICTURE ADDITIONS
    onPictureAddHandler = (e) => {
        if (this.maxSelectFile(e) && this.checkMimeType(e) && this.checkFileSize(e)) {
            var commentImageFiles = e.target.files;
            this.setState(() => ({ commentImageFiles }));
        }
    }

    maxSelectFile = (e) => {
        let files = e.target.files
        if (files.length > 1) {
            const msg = 'Only 1 image can be attached with comment'
            e.target.value = null
            alert(msg)
            return false;
        }
        return true;
    }

    checkFileSize = (e) => {
        let files = e.target.files
        let size = 5242880;
        let err = "";
        for (var x = 0; x < files.length; x++) {
            if (files[x].size > size) {
                err = 'File is too large, please pick a smaller file\n';
            }
        };
        if (err !== '') {
            e.target.value = null
            return false
        }
        return true;
    }

    checkMimeType = (e) => {
        let files = e.target.files
        let err = ''
        const types = ['image/jpeg', 'image/png', 'image/JPEG', 'image/PNG']
        for (var x = 0; x < files.length; x++) {
            if (!types.includes(files[x].type)) {
                err = 'File is not in a supported format\n';
            }
        };
        if (err !== '') {
            e.target.value = null // discard selected file
            return false;
        }
        return true;
    }

    /// README: SORTING THE COMMENTS MAP
    sortComments = (a, b) => {
        if ('timestamp' in a && 'timestamp' in b) {
            if (a.timestamp < b.timestamp) {
                return -1;
            }
            if (a.timestamp > b.timestamp) {
                return 1;
            }
        }
        return 0;
    }

    /// README: SETTING COMMENT TEXT
    handleComment = (e) => {
        this.setState({ commentText: e.target.value })
    }

    /// README: SUBMITTING THE COMMENT
    handleSubmit = (e) => {
        e.preventDefault();
        const { selectedMarkerid, userData, snagDetail } = this.props;
        const { proid } = snagDetail;
        const { commentText, commentImageFiles } = this.state;

        if (commentText.length > 0) {
            this.props.addAComment(userData, proid, selectedMarkerid, commentText, commentImageFiles);
            this.setState({
                commentText: "",
                commentImageFiles: [],
            });
        } else {
            alert("Empty comment cannot be placed");
        }
    }


    handleOpenCommentDeleteModel = (toBeDeletedCommentMap) => {
        this.props.openDeleteCommentModal();
        this.setState({ showCommentDeleteModal: true, toBeDeletedCommentMap, });
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = (num, commentMap) => {
        switch (num) {
            case 0: {
                this.setState({ showCommentImageModal: true, commentMap, });
                break;
            } case 1: {
                this.setState({ showEditMarkerModal: true });
                break;
            }
            default: {
                this.setState({ showCommentImageModal: false, showEditMarkerModal: false });
            }
        }
    }

    handleCloseModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({ showCommentImageModal: false, commentMap: undefined, });
                break;
            } case 1: {
                this.setState({ showEditMarkerModal: false });
                break;
            }

            case 2: {
                this.setState({ showCommentDeleteModal: false })
                break;
            }
            default: {
                this.setState({ showCommentImageModal: false, showEditMarkerModal: false });
            }
        }
    }

    /// README: RENDER THE UI
    render() {
        const { isCommentAdding } = this.props.sketch;

        const relevantSubmitComponent = isCommentAdding ?
            (<React.Fragment>
                <Loader
                    type="TailSpin"
                    color={this.props.themeColors.themeColor}
                    height={20}
                    width={20}
                />
            </React.Fragment>)
            :
            (<React.Fragment>
                <label className="mx-1 btn btn-sm btn-flat" htmlFor="newCommentFiles" role="button"><MDICONS.AddAPhotoOutlined /></label>
                <label className="mx-1 btn btn-sm btn-light" role="button" onClick={this.handleSubmit}><MDICONS.SendRounded /></label>
            </React.Fragment>);



        const { selectedMarkerid, floorMarkers, modalWidthMedium, modalTitleStyle, mut, modalStyles,
            userData, alu,
            comments,
            isElevationMap,
            snagDetail,
            defectMarker, defectMarkers, appControl, sketch,
        } = this.props;
        const { markerEditingAccess } = alu;
        const { uid, employeeid } = userData;
        const { commentText, commentImageFiles, commentMap } = this.state;

        /// this is placed to pause snagDetail related stuff while snagDetail is not available
        if (!snagDetail) {
            return <React.Fragment />
        }

        const { accessMap, proid } = snagDetail;

        const floorMarker = floorMarkers ? selectedMarkerid in floorMarkers ? floorMarkers[selectedMarkerid] : null : null;
        const relevantEditMarkerComponent = floorMarker ? floorMarker.identifier === "0" ? <BriefDefect selectedMarkerid={selectedMarkerid} /> : floorMarker.identifier === "1" ? <BriefElevation selectedMarkerid={selectedMarkerid} /> : <p>Nothing found </p> : <p>Nothing found</p>
        const floorMarkerText = mut.text[floorMarker.identifier];

        /// README: CHECKING ACCESS LEVEL FOR EDITING
        /// getting ueid to pass into accessMap of project to get accessLevel
        var ueid = uid + employeeid;
        var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
        var isMarkerEditingAllowed = markerEditingAccess[accessLevel];
        const editButton = isMarkerEditingAllowed ? <button className="btn btn-outline-dark btn-sm" onClick={() => { this.handleOpenModal(1) }}>Edit {floorMarkerText}</button> : <React.Fragment />;

        return (
            <React.Fragment>
                <div className="dynamicModalContainer">
                    <div className="dynamicModalSm">
                        <div className="d-flex justify-content-between">
                            <div className="d-flex flex-row">
                                <div className="align-self-center">
                                    <div className="align-self-start">
                                        <h5 style={modalTitleStyle}>View {floorMarkerText}</h5>
                                        <p style={appControl.modalInfoTextStyle}>Brief details about {floorMarkerText}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex flex-row">
                                <div className="align-self-center">
                                    <div className="align-self-end mr-4">
                                        {editButton}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        {/* MARKER FORM */}
                        {relevantEditMarkerComponent}
                        <br />

                        {/* COMMENTS */}
                        <div className="card">
                            <div className="input-group mt-2 px-3">
                                <input type="file" className="file" id="newCommentFiles" hidden multiple onChange={this.onPictureAddHandler} />
                                <input type="text" className="form-control form-control-sm border-0" placeholder="Add a comment" aria-label="Add a comment" aria-describedby="basic-addon2" onChange={this.handleComment} value={commentText} />
                                <div className="input-group-append">
                                    {relevantSubmitComponent}
                                </div>
                            </div>
                            {commentImageFiles.length > 0 ? <p className="px-3" style={{ fontSize: "10px", color: "GrayText" }}>Picture attached</p> : <React.Fragment />}
                            <hr />
                            {comments !== undefined ? comments !== null ? Object.keys(comments).length > 0 ? Object.values(comments).sort(this.sortComments).map((val, i) => {
                                const parsedDate = new Date(val.timestamp);
                                const momentDate = moment(parsedDate).fromNow();

                                const viewImagesButton = 'imageFiles' in val ? [...val.imageFiles].length > 0 ? <img src={[...val.imageFiles][0]} alt="" title={val.comment} onClick={() => { this.handleOpenModal(0, val) }} height="70px" /> : <React.Fragment /> : <React.Fragment />;
                                return (
                                    <React.Fragment key={val.cid}>
                                        <div className="d-flex justify-content-between mx-3 mb-3" key={val.cid}>
                                            <div className="d-flex flex-row">
                                                <div className="align-self-center mr-3">
                                                    <img src={`https://avatars.dicebear.com/api/identicon/${val.uid}.svg?backgroundColor=%23ffffff`} alt="user" className="avatar-square" style={{ width: "45px", height: "45px" }} />
                                                </div>
                                                <div className="align-self-center">
                                                    <div className="d-flex flex-column">
                                                    {/* <button onClick={() => { this.handleOpenCommentDeleteModel(val) }}> Delete </button> */}
                                                        <div className="align-self-sm-start"><span style={{ fontSize: "12px", fontWeight: "bold" }}>{val.name}</span></div>
                                                        <div className="align-self-sm-start"><span style={{ fontSize: "12px" }}>{val.comment}</span></div>
                                                        <div className="align-self-sm-start">{viewImagesButton}</div>
                                                        <div className="align-self-start"><span style={{ fontSize: "10px", color: "GrayText" }}>{momentDate} • {parsedDate.toUTCString()}</span></div>
                                                        <div className="align-self-sm-start"> <a href="#!" role="button"  style={{fontSize:'10px',color:'gray'}} onClick={() => { this.handleOpenCommentDeleteModel(val) }}> Delete </a></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )
                            }) : <span className="px-4 pb-2" style={{ fontSize: '14px', color: 'gray', fontStyle: "italic" }}>No comments found</span> : <span className="px-4 pb-2" style={{ fontSize: '14px', color: 'gray', fontStyle: "italic" }}>No comments found</span> : <span className="px-4 pb-2" style={{ fontSize: '14px', color: 'gray', fontStyle: "italic" }}>Loading comments...</span>}
                        </div>
                        <br />
                    </div>
                </div>

                {/* COMMENT IMAGE PREVIEW MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showCommentImageModal}
                    onRequestClose={() => { this.handleCloseModal(0) }}
                    contentLabel="Comment image"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal(0) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="dynamicModalContainer">
                        <div className="dynamicModalSm" style={{ overflowX: 'auto' }}>
                            {commentMap !== undefined ? <img src={[...commentMap.imageFiles][0]} alt="" title={commentMap.comment} height='580px' width="550px" /> : <p>loading...</p>}
                        </div>
                    </div>
                </ReactModal>

                {/* EDIT MARKER MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showEditMarkerModal}
                    onRequestClose={() => { this.handleCloseModal(1) }}
                    contentLabel="Edit marker modal"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal(1) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <EditMarkerWrapper defectMarkers={defectMarkers} defectMarker={defectMarker} selectedMarkerid={selectedMarkerid} isElevationMap={isElevationMap} />
                </ReactModal>

                {/* DELETE COMMENT MODAL */}
                <ReactModal
                    style={modalStyles}
                    // isOpen={this.state.showCommentDeleteModal}
                    isOpen={this.state.showCommentDeleteModal && !sketch.isCommentDeleted}
                    onRequestClose={() => { this.handleCloseModal(2) }}
                    contentLabel="Comment delete modal"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal(2) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    {
                        this.state.toBeDeletedCommentMap ? <DeleteCommentModal proid={proid} cid={this.state.toBeDeletedCommentMap.cid} selectedMarkerid={selectedMarkerid} /> : <p></p>
                    }
                </ReactModal>

            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        themeColors: state.theme,
        appControl: state.appControl,
        modalStyles: state.appControl.modalStyles,
        formLabelStyle: state.appControl.formLabelStyle,
        modalWidthMedium: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        floorMarkers: state.firestore.data.FloorMarkers,
        mut: state.marker,
        userData: state.firebase.profile,
        alu: state.alu,
        comments: get(state.firebase.data, `Projects.${state.project.snagDetail.proid}.Markers.${props.selectedMarkerid}.Comments`),
        sketch: state.sketch,

        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addAComment: (userData, proid, markerid, comment, imageFiles) => dispatch(addAComment(userData, proid, markerid, comment, imageFiles)),
        deleteAComment: (proid, markerid, cid) => dispatch(deleteAComment(proid, markerid, cid)),
        openDeleteCommentModal: () => dispatch(openDeleteCommentModal()),
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firebaseConnect((props) => {
        const { selectedMarkerid, project } = props;
        const { proid } = project.snagDetail;
        return [
            `Projects/${proid}/Markers/${selectedMarkerid}/Comments`
        ]
    }),
)(BriefMarkerWrapper)
